import { render, staticRenderFns } from "./loseStyle.vue?vue&type=template&id=701a042c&"
import script from "./loseStyle.vue?vue&type=script&lang=js&"
export * from "./loseStyle.vue?vue&type=script&lang=js&"
import style0 from "./loseStyle.vue?vue&type=style&index=0&id=701a042c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports